const editorAddPost = document.querySelector('.editor-add-post');
const btnNewPost = document.querySelector('.btn-new-post');
const addPostContainer = document.querySelector('.add-post-container');

// Create success message container outside the form
const successContainer = document.createElement('div');
successContainer.className = 'post-success-message';
if (addPostContainer) {
    addPostContainer.insertBefore(successContainer, editorAddPost);
}

// Toggle form visibility when "Nytt innlegg" button is clicked
if (btnNewPost && editorAddPost) {
    btnNewPost.addEventListener('click', () => {
        // Hide the button
        btnNewPost.style.display = 'none';

        // Show the form
        editorAddPost.classList.add('visible');

        // Expand the form to show buttons
        const form = editorAddPost.querySelector('.wall-form');
        if (form) {
            form.classList.add('expand');
        }

        const titleInput = editorAddPost.querySelector('input[name="title"]');
        if (titleInput) {
            titleInput.focus();
        }
    });
}

if(editorAddPost) {
    const form = editorAddPost.querySelector('.wall-form');
    const titleInput = form.querySelector('input[name="title"]');
    const textarea = form.querySelector('textarea[name="post-content"]');
    const postTypeInput = form.querySelector('input[name="post_type"]');
    const fileInput = form.querySelector('input[type="file"]');
    const uploadLabel = form.querySelector('label.image-upload');
    const submitButton = form.querySelector('button.submit-btn');
    const removeButton = form.querySelector('button.remove-post');
    const loadingSpinner = form.querySelector('.loading-spinner');
    const toggleDepartmentsBtn = form.querySelector('.toggle-departments');
    const departmentsList = form.querySelector('.departments-list');
    const departmentSelector = form.querySelector('.department-selector');

    let selectedFile = null;
    let isUploading = false;

    const FILE_LIMITS = {
        maxFileSize: 25 * 1024 * 1024, // 25MB in bytes
        allowedTypes: ['image/jpeg', 'image/png', 'image/gif']
    };

    // Error message container
    const errorContainer = document.createElement('div');
    errorContainer.className = 'upload-errors';
    const buttonActions = form.querySelector('.button-actions');
    form.insertBefore(errorContainer, buttonActions);

    // Create, show and hide error/success message
    function showMessage(message, duration = 5000, isSuccess = false) {
        const className = isSuccess ? 'success' : 'error';

        // Success messages go in successContainer (outside form), errors in errorContainer (inside form)
        const container = isSuccess ? successContainer : errorContainer;

        if (container) {
            container.innerHTML = `<p class="${className}">${message}</p>`;
            container.style.display = 'block';
            setTimeout(() => {
                container.style.display = 'none';
                container.innerHTML = '';
            }, duration);
        }
    }

    // Backwards compatibility
    function showError(message, duration = 5000) {
        showMessage(message, duration, false);
    }

    function formatFileSize(bytes) {
        if (bytes < 1024) return bytes + ' B';
        else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        else return (bytes / 1048576).toFixed(1) + ' MB';
    }

    function validateFile(file) {
        const errors = [];

        // Check file type
        if (!FILE_LIMITS.allowedTypes.includes(file.type)) {
            errors.push(`Ugyldig filtype. Bruk JPG, PNG eller GIF`);
        }

        // Check individual file size
        if (file.size > FILE_LIMITS.maxFileSize) {
            const maxSize = formatFileSize(FILE_LIMITS.maxFileSize);
            const fileSize = formatFileSize(file.size);
            errors.push(`Filen er for stor (${fileSize}). Maksimal størrelse er ${maxSize}`);
        }

        return errors;
    }

    function updateUploadButton() {
        if (selectedFile) {
            uploadLabel.classList.add('hide');
        } else {
            uploadLabel.classList.remove('hide');
        }
    }

    function resetForm() {
        titleInput.value = '';
        textarea.value = '';
        uploadLabel.classList.remove('hide');
        selectedFile = null;

        const imagesWrapper = form.querySelector('.images-wrapper');
        if (imagesWrapper) {
            imagesWrapper.innerHTML = '';
        }

        // Reset department checkboxes and collapse the section
        const departmentCheckboxes = form.querySelectorAll('input[name="departments[]"]');
        departmentCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        if (toggleDepartmentsBtn && departmentsList) {
            toggleDepartmentsBtn.classList.remove('expanded');
            departmentsList.classList.remove('expanded');
        }

        // Remove expand class only if form is not visible (not opened via button)
        if (!editorAddPost.classList.contains('visible')) {
            form.classList.remove('expand');
        }

        updateUploadButton();
    }

    // Form event handlers
    function checkExpand() {
        const titleValue = titleInput.value.trim();
        const textValue = textarea.value.trim();
        const hasContent = titleValue !== '' || textValue !== '';

        if(hasContent && !form.classList.contains('expand')) {
            form.classList.add('expand');
        }
        // Don't collapse if form is open via "Nytt innlegg" button
        else if(!hasContent && !form.querySelectorAll('.images-wrapper figure').length && !editorAddPost.classList.contains('visible')) {
            form.classList.remove('expand');
        }
    }

    titleInput.addEventListener('keyup', checkExpand);
    textarea.addEventListener('keyup', checkExpand);

    // Toggle departments list
    if (toggleDepartmentsBtn && departmentsList) {
        toggleDepartmentsBtn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleDepartmentsBtn.classList.toggle('expanded');
            departmentsList.classList.toggle('expanded');
        });
    }

    fileInput.addEventListener('change', async (e) => {
        if (isUploading) {
            showError('Vennligst vent til nåværende opplasting er ferdig');
            fileInput.value = '';
            return;
        }

        const file = e.target.files[0];
        if (!file) return;

        const errors = validateFile(file);

        if (errors.length > 0) {
            showError(errors.join('<br>'));
            fileInput.value = '';
            return;
        }

        try {
            selectedFile = file;
            form.classList.add('expand');
            await insertImage(selectedFile);
        } catch (error) {
            console.error('File handling error:', error);
            showError('Feil ved håndtering av fil');
            selectedFile = null;
        }

        fileInput.value = '';
        updateUploadButton();
    });

    async function insertImage(file) {
        if (isUploading) return;

        isUploading = true;
        submitButton.disabled = true;
        updateUploadButton();

        try {
            const data = new FormData();
            data.append('action', 'insert_editor_image');
            data.append('file-0', file);

            loadingSpinner?.classList.add('show');

            const response = await $.ajax({
                url: feltpost_scripts.ajax_url,
                type: 'POST',
                data: data,
                cache: false,
                processData: false,
                contentType: false
            });

            const imagesWrapper = form.querySelector('.images-wrapper');
            if (!imagesWrapper) {
                throw new Error('Images wrapper not found');
            }

            imagesWrapper.innerHTML = response;

            const removeBtn = imagesWrapper.querySelector('.remove-image');
            if (removeBtn) {
                removeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    selectedFile = null;
                    imagesWrapper.innerHTML = '';
                    updateUploadButton();
                    checkExpand();
                });
            }

        } catch (error) {
            console.error('Upload error:', error);
            showError('Feil ved opplasting av bilde. Vennligst prøv igjen.');
        } finally {
            loadingSpinner?.classList.remove('show');
            submitButton.disabled = false;
            isUploading = false;
            updateUploadButton();
        }
    }

    async function addPost() {
        const title = titleInput.value.trim();
        const content = textarea.value.trim();
        const postType = postTypeInput.value || 'post';
        const editPostId = form.getAttribute('data-edit-post-id');

        if (!title) {
            showError('Legg til en overskrift før du publiserer');
            return;
        }

        if (!content && !selectedFile) {
            showError('Legg til innhold eller et bilde før du publiserer');
            return;
        }

        submitButton.disabled = true;

        try {
            let imageId = null;
            const imageElement = form.querySelector('.images-wrapper figure img');

            if (imageElement?.dataset.id) {
                imageId = imageElement.dataset.id;
            }

            // Collect selected departments
            const selectedDepartments = [];
            const departmentCheckboxes = form.querySelectorAll('input[name="departments[]"]:checked');
            departmentCheckboxes.forEach(checkbox => {
                selectedDepartments.push(checkbox.value);
            });

            const data = new FormData();
            data.append('action', 'add_editor_post');
            data.append('title', title);
            data.append('content', content);
            data.append('post_type', postType);
            if (imageId) {
                data.append('image_id', imageId);
            }
            if (selectedDepartments.length > 0) {
                data.append('departments', JSON.stringify(selectedDepartments));
            }
            if (editPostId) {
                data.append('post_id', editPostId);
            }

            const response = await $.ajax({
                url: feltpost_scripts.ajax_url,
                type: 'POST',
                data: data,
                cache: false,
                processData: false,
                contentType: false
            });

            if (response.success) {
                // Hide the form first (so resetForm can remove expand class)
                editorAddPost.classList.remove('visible');

                // Reset form and edit mode
                form.removeAttribute('data-edit-post-id');

                // Reset submit button text if editing
                const originalText = submitButton.getAttribute('data-original-text');
                if (originalText) {
                    submitButton.innerHTML = originalText;
                    submitButton.removeAttribute('data-original-text');
                }

                resetForm();

                // Show the "Nytt innlegg" button again
                if (btnNewPost) {
                    btnNewPost.style.display = '';
                }

                // Show success message (will appear above the button)
                const successMsg = editPostId ? 'Innlegget ble oppdatert!' : 'Innlegget ble publisert!';
                showMessage(successMsg, 2000, true);

                // Reload page after short delay to show new/updated post
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                showError(response.data?.message || 'Feil ved publisering');
                submitButton.disabled = false;
            }

        } catch (error) {
            console.error('Post error:', error);
            showError('Feil ved publisering. Vennligst prøv igjen. ');
            submitButton.disabled = false;
        }
    }

    submitButton.addEventListener('click', async (e) => {
        e.preventDefault();
        await addPost();
    });

    removeButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Hide the form first (so resetForm can remove expand class)
        editorAddPost.classList.remove('visible');

        // Reset edit mode
        form.removeAttribute('data-edit-post-id');

        // Reset submit button text if editing
        const originalText = submitButton.getAttribute('data-original-text');
        if (originalText) {
            submitButton.innerHTML = originalText;
            submitButton.removeAttribute('data-original-text');
        }

        // Reset the form
        resetForm();

        // Show the "Nytt innlegg" button again
        if (btnNewPost) {
            btnNewPost.style.display = '';
        }
    });
}
